var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { getComputedStyleFromLayoutProps, removeValues } from '../util';
var valuesToRemove = [undefined];
/**
 * A hook that calculates inline styles for a component based on layout props.
 *
 * @private
 */
export function useLayoutProps(_a) {
    var layout = _a.layout, style = _a.style, topLevelLayoutProps = _a.topLevelLayoutProps;
    return React.useMemo(function () {
        return getComputedStyleFromLayoutProps(style, __assign(__assign({}, (topLevelLayoutProps && removeValues(topLevelLayoutProps, valuesToRemove))), (layout && removeValues(layout, valuesToRemove))));
    }, [layout, style, topLevelLayoutProps]);
}
